import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label } from "reactstrap";
import Modal from "../../../../components/Modal";
import Button from "../../../../components/Button";
import "./style.scss";

const CONFIRM_WORD = "DISCONNECT";

function DisconnectModal({ isOpen, loading, error, onCancel, onConfirm }) {
	const { t } = useTranslation();
	const [typed, setTyped] = useState("");

	useEffect(() => {
		if (!isOpen) {
			setTyped("");
		}
	}, [isOpen]);

	const canConfirm = typed.trim() === CONFIRM_WORD && !loading;

	const onSubmit = useCallback(
		(e) => {
			e.preventDefault();
			if (canConfirm) {
				onConfirm();
			}
		},
		[canConfirm, onConfirm],
	);

	return (
		<Modal
			isOpen={isOpen}
			toggle={loading ? undefined : onCancel}
			title={<span id="hibob-disconnect-title">{t("hibob-disconnect-title")}</span>}
			trapFocus
			returnFocusAfterClose
			labelledBy="hibob-disconnect-title"
			centered
		>
			<form onSubmit={onSubmit}>
				<p id="hibob-disconnect-description">{t("hibob-disconnect-text")}</p>
				<FormGroup>
					<Label for="hibob-disconnect-confirm">{t("hibob-disconnect-type")}</Label>
					<Input
						id="hibob-disconnect-confirm"
						value={typed}
						onChange={(e) => setTyped(e.target.value)}
						autoComplete="off"
						autoFocus
						aria-describedby="hibob-disconnect-description"
					/>
				</FormGroup>
				{error && (
					<p role="alert" className="hibob-danger-text text-sm">
						{error}
					</p>
				)}
				<div className="d-flex justify-content-end">
					<Button type="button" color="light" onClick={onCancel} disabled={loading}>
						{t("cancel")}
					</Button>
					<Button
						type="submit"
						color="danger"
						disabled={!canConfirm}
						loading={loading}
					>
						{t("hibob-disconnect")}
					</Button>
				</div>
			</form>
		</Modal>
	);
}

export default DisconnectModal;
